import styled, { css } from 'styled-components';
import { path } from '../../../../../common/css/setting/variable';

interface IProps {
  type: 'PAY' | 'NEW' | 'LIVE';
  className?: string;
}

const Label = styled.span<{ $type: IProps['type'] }>`
  display: inline-block;
  width: 27px;
  height: 12px;
  font-size: 0; /* 縦を揃える */
  vertical-align: middle;
  background-size: 27px 12px;

  ${({ $type }) => {
    switch ($type) {
      case 'PAY':
        return css`
          background-image: url(${path.img_labelIcon_pay});
        `;
      case 'NEW':
        return css`
          background-image: url(${path.img_labelIcon_new});
        `;
      case 'LIVE':
        return css`
          background-image: url(${path.img_labelIcon_live});
        `;
      default:
        return;
    }
  }}
`;

function getAriaLabel(type: string): string | undefined {
  switch (type) {
    case 'PAY':
      return '有料';
    case 'NEW':
      return 'NEW';
    case 'LIVE':
      return 'ライブ';
    default:
      return undefined;
  }
}

const LabelIcon: React.FC<IProps> = props => {
  const ariaLabel = getAriaLabel(props.type);

  return <Label $type={props.type} aria-label={ariaLabel} className={props.className} role="img" />;
};

export default LabelIcon;
